import React, { Component } from 'react';
import Loading from '../Loading.js';
import {baseUrl} from '../../common/config.js';
import { Redirect } from 'react-router';
import Menu from '../Menu.js'
import Paper from 'material-ui/Paper';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import IconButton from 'material-ui/IconButton';
import {apiService} from '../../common/apiCallService';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

class PromotionalContentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading : false,
      loginRedirect : false,
      title : 'Promotional Content',
      sortBy : 'asc',
      sortColumn : 'title',
      max: 10,
      totalCount: 10,
      offset: 0,
      access: JSON.parse(localStorage.getItem('userRole')),
      contentList : [],
      deleteDialogOpen : false
    }
    this.columnSort = this.columnSort.bind(this)
    this.handleDeleteDialogOpen = this.handleDeleteDialogOpen.bind(this);
    this.handleDeleteDialogClose = this.handleDeleteDialogClose.bind(this);
    this.deletePrCo = this.deletePrCo.bind(this);
    this.callApi();
  }

  componentDidMount() {
    createVirtualPageLoad("/promotionalContentList")
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  columnSort(column) {
    this.setState({loading : true});
    if(column == this.state.sortColumn) {
      if(this.state.sortBy == 'asc') this.state.sortBy = 'desc'
      else this.state.sortBy = 'asc'
    } else {
      this.state.sortBy = 'asc'
    }
    this.setState({sortColumn : column})
    this.callApi();
  }

  handleDeleteDialogOpen = () => {
    this.setState({deleteDialogOpen : true})
  }

  handleDeleteDialogClose = () => {
    this.setState({deleteDialogOpen : false})
  }

  callApi() {
     const {max,offset,sortBy,sortColumn} = this.state;
    apiService(baseUrl + '/promotionalContent/list', {max,offset,sortBy,sortColumn},
    (data) => {
      this.setState({contentList : data});
    }, (data) => {
      this.setState({loginRedirect : true})
    })
    this.setState({loading : false});
  }

  deletePrCo = (id) => {
    console.log("deletetin");
    console.log(id);
    apiService(
      baseUrl + '/promotionalContent/delete' ,
      {id},
      (data) => {
        this.callApi();
      },
      (data) => {
        this.setState({loginRedirect : true})
      }
    )
    this.handleDeleteDialogClose();
  }
  render() {
    this.props.setHeaderTitle(this.state.title)
    const style = {
      position: 'absolute',
      bottom: 20,
      right: 20
    };

    const actions = [
      <FlatButton
        label="yes"
        primary={true}
        onClick={() => {this.deletePrCo(this.state.deleteId)}}
      />,
      <FlatButton
        label="No"
        primary={true}
        onClick={this.handleDeleteDialogClose}
      />,
    ];

    return(
      <div>
        {this.state.loading ? <Loading/> : null}
        {this.state.loginRedirect && (<Redirect to={'/'}/>)}
        <Dialog
          title="Dialog With Actions"
          actions={actions}
          modal={false}
          open={this.state.deleteDialogOpen}
          onRequestClose={this.handleDeleteDialogClose}
        >
        Are you sure?
        </Dialog>
        <Paper zDepth={1} rounded={false} className="resp-paper">
          {
            this.state.totalCount == 0 ?
              <div>
                <h5><center>No Data Available For Given Search</center></h5>
              </div>
            :
            <div>
            <Link  style={{textDecoration:"none"}}  to={'/promotionalContent/new'}>
            <RaisedButton label="ADD NEW" data-e2e="addnew" secondary={true} style={{float: 'right'}}/>
            </Link>
              <table className="resp-table resp-table-background">
                <thead className="resp-table-head">
                  <tr className="resp-table-tr">
                    <th onTouchTap={() =>  this.columnSort('title')} className="resp-table-th">
                      Title&nbsp;<i className="fa fa-sort " data-e2e="title" ></i>
                    </th>
                    <th onTouchTap={() =>  this.columnSort('max_range')} className="resp-table-th">
                      Min Range&nbsp;<i className="fa fa-sort " data-e2e="Minimum Range" ></i>
                    </th><th onTouchTap={() =>  this.columnSort('min_range')} className="resp-table-th">
                      Max Range&nbsp;<i className="fa fa-sort " data-e2e="Max Range" ></i>
                    </th><th onTouchTap={() =>  this.columnSort('Created_date')} className="resp-table-th">
                      Created Date&nbsp;<i className="fa fa-sort " data-e2e="created Date"  ></i>
                    </th>
                    <th  className="resp-table-th">
                    </th>
                    <th  className="resp-table-th">
                    </th>
                  </tr>
                </thead>
                <tbody className="resp-table-body">
                {this.state.contentList.map((item, key) => {
                    return (
                      <tr key={key} className="resp-table-tr">
                            <td className="UserList resp-table-td">{item.title}</td>
                            <td className="UserList resp-table-td">{item.min_range}</td>
                            <td className="UserList resp-table-td">{item.max_range}</td>
                            <td className="UserList resp-table-td">{moment(item.Created_date).format("YYYY-MM-DD HH:mm:ss")}</td>
                            <td className="UserList resp-table-td" style={{padding: '0px'}}>
                              <Link  style={{textDecoration:"none"}}  to={'/promotionalContent/edit/'+item._id}>
                                <IconButton iconClassName="fa fa-edit" data-e2e="edit" />
                              </Link>
                            </td>
                            <td className="UserList resp-table-td" style={{padding: '0px'}} onTouchTap={()=>{
                              this.setState({deleteId : item._id})
                              this.handleDeleteDialogOpen()}} >
                              <IconButton iconClassName="fa fa-trash-o"/>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
              </table>
              </div>
          }
          </Paper>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(PromotionalContentList);



/** WEBPACK FOOTER **
 ** ./src/components/PromotionalContent/PromotionalContentList.js
 **/